import React, { useEffect, useState } from 'react'
import {
    Tooltip,
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Dialog,
    DialogContent,
    Chip,
    Button,
    MenuItem,
} from '@mui/material'
import { Formik } from 'formik'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SupplierDialog from '../Components/SupplierDialog';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import CreateIcon from '@mui/icons-material/Create';
import { toast, useToastContainer } from 'react-toastify';
import SearchIcon from '@mui/icons-material/Search';
import ItemDialog from '../Components/ItemDialog';
import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import logo from '../Assests/paw.png'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Navigate, useNavigate } from 'react-router-dom';
import UserDialog from '../Components/UserDialog';
import DeleteIcon from '@mui/icons-material/Delete';



function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function UserManagement() {
    const [pageTitle, setPageTitle] = useState('Algama User Management');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [itemList, setItemList] = useState([]);
    const [itemSearch, setItemSearch] = useState("");
    const [listImageView, setListImageView] = useState();
    const [imageDialog, setImageDialog] = useState(false);
    const [updateID, setUpdateID] = useState(0);
    const [status, setStatus] = useState(1);
    const [itemGridList, setItemGridList] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        GetAllItemDetailForGrid();
    }, [])

    useEffect(() => {
        if (updateID === 0 && dialogOpen === false) {
            GetAllItemDetailForGrid();
        }
    }, [updateID])

    useEffect(() => {
        GetAllItemDetailForGrid();
    }, [status])

    useEffect(() => {
        if (dialogOpen === false) {
            GetAllItemDetailForGrid();
        }
    }, [dialogOpen])

    function handleClick() {
        setDialogOpen(true);
    }

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - itemGridList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    function GetAllItemDetailForGrid() {
        axios.get('https://serveralgama.mylksystems.com/Users/getUser').then((res) => {
            if (res.data.length > 0) {
                setItemList(res.data);
                const FilterData = res.data.filter(itemStatus => itemStatus.IsActive === status);
                setItemGridList(FilterData);
            } else {
                setItemList([]);
                toast.error("No records to display!");
            }
        })
    }

    function ViewImage(itemImage) {
        setListImageView(itemImage);
        setImageDialog(true)
    }

    function UpdateRowData(rowID) {
        const data = {
            rowID
        }

        axios.delete(`https://serveralgama.mylksystems.com/Users/deleteUser/${rowID}`).then((res) => {
            toast.success("User Deleted");
            GetAllItemDetailForGrid()
        }).catch((e) => {
            toast.error(e)
        }
        )
    }

    function removeImage() {
        setImageDialog(false)
    }

    function handleClickback() {
        navigate(-1);
    }
    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={12} xs={12}>
                    <Box display='flex' justifyContent='flex-start' alignItems='center' >

                        <Button variant="contained" endIcon={<ArrowBackIcon />} onClick={() => handleClickback()} >
                            Back
                        </Button>

                    </Box>
                </Grid>
                <Grid item md={11} xs={11}>
                    {titleName}
                </Grid>
                <Grid item md={1} xs={1}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center' >

                        <Button variant="contained" endIcon={<AddCircleOutlineIcon />} onClick={() => handleClick()} sx={{ width: '100%' }}>
                            Add
                        </Button>

                    </Box>
                </Grid>
            </Grid>
        )
    }

    return (
        <>
            <Container maxWidth={false} sx={{ paddingTop: '15vh' }}>
                <Formik
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form >
                            <Card sx={{ padding: '15px' }}>
                                <CardHeader
                                    title={cardTitle(pageTitle)}
                                />
                                <Divider />
                                <br />
                                <TableContainer>
                                    <Grid container spacing={2}>
                                        <Grid item md={6} sx={6}>
                                            <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                                <SearchIcon sx={{ color: 'action.active', mr: 1, my: 1 }} />
                                                <TextField
                                                    sx={{ width: { md: '50%', xs: '60%' } }}
                                                    variant="outlined"
                                                    value={itemSearch}
                                                    onChange={(e) => { setItemSearch(e.target.value) }}
                                                    size='small'
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>#</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>User Name</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>User Email</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>User Role</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? itemList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : itemList
                                            ).filter((element) => {
                                                if (itemSearch === "") {
                                                    return element;
                                                } else if ((element.Name.toLowerCase().trim()).includes(itemSearch.toLowerCase().trim())) {
                                                    return element;
                                                }
                                            }).map((row, index) => (
                                                <TableRow key={row._id}>
                                                    <TableCell align='center'>{index + 1}</TableCell>
                                                    <TableCell align='center'>{row.Name}</TableCell>
                                                    <TableCell align='center'>{row.email}</TableCell>
                                                    <TableCell align='center'>{row.role == 1 ? "Admin" : row.role == 2 ? "Cashier" : row.role == 3 ? "Accountant" : "Store Keeper"} </TableCell>
                                                    <TableCell align='center'>
                                                        <IconButton>
                                                            <DeleteIcon sx={{ color: 'black' }} onClick={() => UpdateRowData(row.userkey)} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={8} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 25, 35, { label: 'All', value: -1 }]}
                                                    colSpan={8}
                                                    count={itemGridList.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    slotProps={{
                                                        select: {
                                                            inputProps: {
                                                                'aria-label': 'rows per page',
                                                            },
                                                            native: true,
                                                        },
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </form>
                    )}

                </Formik>
            </Container>

            {/* item manegemnet dialog box */}
            <UserDialog
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                updateID={updateID}
                setUpdateID={setUpdateID}
            />
        </>
    )
}

export default UserManagement